<template>
  <div class="add-ciec is-flex is-centered">
    <b-button
      v-if="hasCiec"
      class="ciec-sync-button"
      size="is-medium"
      type="is-primary"
      icon-left="sync"
      @click="forceSync"
    >
      Forzar sincronización
    </b-button>
    <transition
      name="add-ciec"
      mode="out-in"
    >
      <add-ciec-form
        v-if="!loading"
        @submit="saveCIEC"
      />
      <add-ciec-loading v-else />
    </transition>
  </div>
</template>

<script>
import get from 'lodash/get';
import merge from 'lodash/merge';
import { createNamespacedHelpers } from 'vuex';

import api from '../../../lib/api';

const { mapState, mapMutations, mapActions } = createNamespacedHelpers('company');

export default {
  name: 'AddCIEC',
  components: {
    AddCiecForm: () => import(/* webpackChunkName: "add-ciec-form" */ '../../../components/Admin/Settings/AddCIECForm.vue'),
    AddCiecLoading: () => import(/* webpackChunkName: "add-ciec-loading" */ '../../../components/Admin/Settings/AddCIECLoading.vue'),
  },
  data() {
    return {
      hasCiec: false,
    };
  },
  computed: merge(
    mapState({
      loading: ({ loading }) => loading,
      ciec: ({ ciec }) => ciec,
    }),
  ),
  mounted() {
    this.hasCiec = !!this.ciec;
  },
  methods: merge(
    mapMutations(['setValue']),
    mapActions(['updateCompany']),
    {
      async saveCIEC() {
        this.setValue({ accessor: 'loading', value: true });

        try {
          await this.updateCompany(this.$route.params.id);

          this.$buefy.toast.open({
            message: `
              La CIEC se guardado correctamente!
              El proceso de extracción suele durar varias horas dependiendo
               de la cantidad de documentos que tengas
            `,
            type: 'is-success',
          });

          this.hasCiec = true;

          if (this.$route.name === 'AddCIEC') this.$router.push({ name: 'StampedList' });
        } catch (error) {
          const invalidCiec = get(error, 'body.data.invalidCiec', false);

          if (invalidCiec) {
            this.$buefy.toast.open({
              message: `
                La CIEC es invalida por favor intenta de nuevo con otra CIEC,
                o corrobora la CIEC proporcionada.
              `,
              type: 'is-danger',
            });
          } else {
            this.$buefy.toast.open({
              message: `
                Ocurrió un error al tratar de guardar la CIEC,
                  si el problema persiste contacta con soporte técnico.
              `,
              type: 'is-danger',
            });
          }
        }

        this.setValue({ accessor: 'loading', value: false });
      },
      async forceSync() {
        this.setValue({ accessor: 'loading', value: true });

        try {
          await api.sync.force();

          this.$buefy.toast.open({
            message: `
              Se forzó la sincronización al SAT, esto puede tardar varias horas.
            `,
            type: 'is-success',
          });
        } catch (error) {
          this.$buefy.toast.open({
            message: `
              Ocurrió un error al solicitar la sincronización al servidor,
                si el problema persiste contacta con soporte técnico.
            `,
            type: 'is-danger',
          });
        }

        this.setValue({ accessor: 'loading', value: false });
      },
    },
  ),
};
</script>

<style scoped>
.ciec-sync-button {
  position: absolute;
  right: 1rem;
  top: 1rem;
}

.add-ciec-enter-active, .add-ciec-leave-active {
  transition: opacity 100ms;
}
.add-ciec-enter, .add-ciec-leave-to {
  opacity: 0;
}
</style>
